import React, { useState } from 'react'
import FormItem from '../../components/Form/FormItem'
import InputNumber from '../../components/Inputs/InputNumber'
import Form from '../../components/Form'
import { useForm } from 'react-hook-form'
import Button from '../../components/General/Button'
import Select from '../../components/Inputs/Select'
import InputText from '../../components/Inputs/InputText'
import { formatPipe } from '../../utils/utils'
import { Alert, Slide, SlideProps, Snackbar } from '@mui/material'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import Bancrecer from '../../assets/images/bancrecer.svg';

type TransitionProps = Omit<SlideProps, 'direction'>

const C2pForm : React.FC<IC2pForm> = ({onSubmit, amount, isLoading = false}) => {

    const form = useForm({defaultValues: {
        amount: formatPipe(amount+"")
      }})

      const docs = [
        {
          value: 'V',
          text: 'V',
        },
        {
          value: 'J',
          text: 'J',
        },
      ]   
      
      const banksOptions = [
        {
          value: '0102',
          text: 'Banco de Venezuela',
        },
        {
          value: '0191',
          text: 'Banco Nacional de Credito',
        },
        {
          value: '0108',
          text: 'Banco Provincial',
        },
        {
          value: '0114',
          text: 'Bancaribe',
        },
        {
          value: '0115',
          text: 'Banco Exterior',
        },
        {
          value: '0163',
          text: 'Banco del Tesoro',
        },
        {
          value: '0134',
          text: 'Banesco',
        },
        {
          value: '0138',
          text: 'Banco Plaza',
        },
        {
          value: '0174',
          text: 'Banplus',
        },
        {
          value: '0169',
          text: 'Mi Banco',
        },
        {
          value: '0157',
          text: 'DEL SUR BU',
        },
        {
          value: '0168',
          text: 'Bancrecer',
        },
        {
          value: '0171',
          text: 'Banco Activo',
        },
        {
          value: '0151',
          text: 'BFC',
        },
        {
          value: '0172',
          text: 'Bancamiga',
        },
        {
          value: '0105',
          text: 'Mercantil',
        },
        {
          value: '0151',
          text: 'BFC',
        },
        {
          value: '0177',
          text: 'BANFANB',
        },
        {
          value: '0175',
          text: 'Bicentenario',
        },
        {
          value: '0137',
          text: 'SOFITASA',
        },
        {
          value: '0166',
          text: 'Agricola',
        },
        {
          value: '0128',
          text: 'Caroni',
        },
        {
          value: '0156',
          text: '100% Banco',
        },
        {
          value: '0104',
          text: 'Venezolano de Credito',
        },
      ]


  const phoneTypes = [
    {
      value: '0412',
      text: '0412',
    },
    {
      value: '0414',
      text: '0414',
    },
    {
      value: '0416',
      text: '0416',
    },
    {
      value: '0424',
      text: '0424',
    },
    {
      value: '0426',
      text: '0426',
    },
  ]

  const bankMessages = [
        {
          value: '0102',
          message:
            '(VÍA PORTAL WEB) Se solicita desde la página web de Banco de Venezuela o SMS 2661 o 2662 + cedula',
        },
        {
          value: '0191',
          message:
            '(VÍA WEB) Pestaña Pagos/Pago Móvil ->Generador Clave C2P Claves a generar -',
        },
        {
          value: '0108',
          message:
            '(VÍA APP ANDROID) Dinero Rápido -> QuieroGenerar Clave de Compra -> Generar Clave',
        },
        {
          value: '0114',
          message: '(VÍA APP) Mi Pago Bancaribe -> Clave Mi Pago Comercio',
        },
        {
          value: '0115',
          message:
            '(VÍA SMS) Envíe al 278 el texto CLAVE V su número de cédula (o E si es extranjero).',
        },
        {
          value: '0163',
          message:
            '(VÍA APP) Debe ingresar a la aplicación “Tesoro Pago Móvil (P2P) y solicitar en esa APP la clave. (VÍA SMS) Envíe al 2383 el texto "Comercio" + V + su número de cédula + (una coordenada a elegir)',
        },
        {
          value: '0134',
          message:
            'Generar Claves Dinámicas a través del portal de Mis Solicitudes banesco o enviando un SMS al número 2846 de la siguiente forma: Coloca la palabra clave dinamica, el tipo de literal: V, E ó J, según sea el caso, y el número de cédula o RIF. Recuerda dejar un espacio entre cada dato. Ejemplo: clave dinamica V 00000000',
        },
        {
          value: '0138',
          message:
            '(VÍA APP) Tu DineroYa -> Generar Token (VÍA SMS) Envíe al 1470 el texto: CLAVE V su número de cédula. (o E si es extranjero) (VÍA WEB) Tu Plaza en Línea',
        },
        {
          value: '0174',
          message: '(VÍA APP) Pago Plus -> Clave C2P',
        },
        {
          value: '0169',
          message: '(VÍA SMS) Envíe al 22622 el texto: PAGAR',
        },
        {
          value: '0157',
          message: '(VÍA SMS) Envíe al 78910 el texto COBROD2',
        },
        {
          value: '0168',
          message: '(VÍA APP) Pag@Ya de Bancrecer. Ahí encuentra la clave C2P.',
        },
        {
          value: '0171',
          message:
            '(VÍA APP) Pago Activo. Ahí encuentra la clave C2P. (VÍA SMS) Envíe al 228486 el texto C2P+TIPO DE DOCUEMENTO+NUMERO DE DOCUMENTO',
        },
        {
          value: '0151',
          message: 'desde la aplicación Tesoro Pago Móvil (P2P).',
        },
        {
          value: '0172',
          message:
            '(Via APP) se obtiene al entrar a Bancamiga Suite y después a Pago Móvil.',
        },
        {
          value: '0105',
          message:
            '(Via APP) de Tpago en el botón Clave C2P o a través de un SMS al 24024 con la palabra ...',
        },
        {
          value: '0151',
          message: '(VÍA APP) Pago Móvil BFC. Ahí encuentra la clave C2P',
        },
        {
          value: '0177',
          message:
            '(VÍA SMS) Envíe al 326200 si es Movistar o Digitel o 78900 si es Movilnet, el texto SERVICIO C2P',
        },
        {
          value: '0175',
          message:
            'En el menú principal da clic a Pago Móvil, escoge la opción Código de Autorización - C2P, por último, selecciona Solicitud del Código de Autorización.',
        },
        {
          value: '0137',
          message:
            '(VÍA APP) Sofitasa Pago Móvil. Ahí encuentra la clave P2C. (VIA WEB) Sofinet personas',
        },
        {
          value: '0166',
          message: 'Banca Móvil o e-banca Personas generar Clave Dinámica.',
        },
        {
          value: '0128',
          message:
            '(VÍA APP) Web Móvil → Solicitud del Código de Autorización (VÍA SMS) Envíe al 100102 el texto: C2P + PAGO + (la clave de transacciones especiales de Pago Móvil) → Le enviarán la Clave C2P.',
        },
        {
          value: '0156',
          message:
            '( Via APP o web 100%Internet Personas y a través de la Web Móvil. Generar Clave Dinamica',
        },
        {
          value: '0104',
          message:
            '(VÍA APP) Venezolano de Crédito AppBvc -> Clave C2P (VÍA WEB) Venezolano Online',
        },
  ]

  const [transition, setTransition] = React.useState<
  React.ComponentType<TransitionProps> | undefined>(undefined)

  const [message, setMessage] = useState<string | null>(null)

  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false)

  function TransitionDown(props: TransitionProps) {
    return <Slide {...props} direction="down" />
  }

  return (
    <>
<Snackbar
        TransitionComponent={transition}
        open={openSnackBar}
        autoHideDuration={30000}
        onClose={() => {
          setOpenSnackBar(false)
          setTimeout(() => {
            setMessage(null)
          }, 200)        
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => {
            setOpenSnackBar(false)
            
          }}
          severity="info"
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>

      <Form
        form={form}
        classes={`gap-x-6 gap-y-2`}
        // id={id}
        onSubmit={(values) => {
          onSubmit(values)
        }}
      >
        <div className="col-span-12" style={{fontWeight: 500}}>Pago en línea (C2P)</div>

        <FormItem
                          name="document.documentType"
                          rules={{ required: 'Es necesario el campo' }}
                          classes="col-span-3"
                          defaultValue={docs[0]}
                        >
                          <Select
                            options={docs}
                            label="Tipo"
                            // value={selectedDoc}
                          />
                        </FormItem>


                        <FormItem
                          name="document.document"
                          classes="col-span-9"
                          rules={{ required: 'Es necesario la cédula' }}
                        >
                          <InputText label="Documento" maxLength={8} />
                        </FormItem>

                        <FormItem
                          name="phone.phoneType"
                          rules={{ required: 'Es necesario el campo' }}
                          classes="col-span-3"
                          defaultValue={phoneTypes[0]}
                        >
                          <Select
                            options={phoneTypes}
                            label="Tipo"
                            // value={selectedDoc}
                          />
                        </FormItem>


                        <FormItem
                          name="phone.number"
                          classes="col-span-9"
                          rules={{ required: 'Es necesario el teléfono' }}
                        >
                          <InputText
                            label="Teléfono"
                            maxLength={10}
                            innerProps={{
                              type: 'number',
                              pattern: 'd*',
                              onKeyPress: (e: any) => {
                                //@ts-ignore
                                if (e.target.value.length >= 8) {
                                  e.preventDefault()
                                  return false
                                }
                              },
                            }}
                          />
                        </FormItem>


                        <FormItem
                          name="bank"
                          classes="col-span-12"
                          rules={{ required: 'Es necesario el banco' }}
                          // defaultValue={banksOptions[0]}
                        >
                          <Select
                            options={banksOptions}
                            label="Bancos"
                            setSelectedHelper={(v) => {
                              // console.log('V', v?.value)
                              if (v?.value) {
                                setTransition(() => TransitionDown)
                                let bankMessage =
                                  bankMessages.find(
                                    (x) => x?.value === v?.value
                                  )?.message || ''
                                // console.log('VER', bankMessage)
                                setOpenSnackBar(true)
                                setMessage(bankMessage)
                                // addAlert({
                                //   message: bankMessage,
                                //   status: 'warning',
                                // })
                              }
                            }}
                          />
                        </FormItem>

                        <FormItem
                          name="token"
                          classes="col-span-8"
                          rules={{ required: 'Es necesaria la clave dinámica' }}
                        >
                          <InputText
                            label="Clave dinámica"
                            innerProps={{
                              type: 'number',
                              pattern: 'd*',
                              onKeyPress: (e: any) => {
                                //@ts-ignore
                                if (e.target.value.length >= 8) {
                                  e.preventDefault()
                                  return false
                                }
                              },
                            }}
                          />
                        </FormItem>

                        <FormItem
          name="amount"
          classes="col-span-4"
          rules={{
            required: 'Es necesario el monto',
          }}
        >
          {/* <InputNumber addDecimals={true} label='Monto' disableInput/> */}
          <CurrencyInput addDecimals={true} mask='Bs. num' label='Monto' disableInput />
        </FormItem>

        {/* <FormItem
          name="amount"
          classes="col-span-12"
          defaultValue={''}
          rules={{
            required: 'Es necesario el monto',
          }}
        >
          <InputNumber addDecimals={true} label='Monto' />
        </FormItem> */}

        <div className="col-span-12 h-full flex flex-row">
          <div className="w-full pr-1">
            <Button type="primary" classes="w-full" htmlType="submit" disabled={isLoading}>
              Continuar
            </Button>
          </div>
        </div>

        <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

      <div className='col-span-12 mt-3 flex flex-col items-center'>
          <label className='text-center text-sm' style={{color: '#7C7C7C'}}>Operación realizada a través de la plataforma de Bancrecer</label>
          <div className='mt-3'>
          <img src={Bancrecer} height={100} width={100}/>
          </div>
      </div>

    </Form>
    </>
  )
}

export default C2pForm

interface IC2pForm {
  onSubmit: (values: any) => void
  amount: number
  isLoading: boolean
}